import React, {useEffect, useState} from "react";
import {Header} from 'semantic-ui-react'
import {Link} from "react-router-dom";
import {useNavigate} from "react-router";
import {OperatingCostList} from "./OperatingCostList";

export default function OperatingCost(props) {
    const [data, setData] = useState({operatingCosts: [], loading: true});

    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Operating costs'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    const fetchData = async () => {
        var url = API_URL + '/api/private/tanker/v1/operating-costs'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setData({operatingCosts: data, loading: false});
            });
    }
    const remove = async (id) => {
        if (confirm(`Realy remove operating cost ${id}?`)) {
            const delete_url = API_URL + '/api/private/tanker/v1/operating-costs/' + id

            const token = sessionStorage.token
            if (!(token && token.length > 0)) navigate('/login')

            fetch(delete_url, {method: 'DELETE', headers: new Headers({'Authorization': `Bearer ${token}`})})
                .then(function (data) {
                    fetchData()
                });
        }
    }
    const {operatingCosts} = data
    return (
        <div>
            <Header>Operating Costs</Header>
            <p><a href="https://docs.google.com/spreadsheets/d/1xt-YnDqW_QAS2bQxb5layAovx02FbSYGqNj-bJsZz5w/edit#gid=443232702"
                  target="_blank">Google Sheets Operating Costs</a></p>
            <p><Link to="/operating-costs/new" as="a">Add new </Link></p>
            <OperatingCostList operatingCosts={operatingCosts} remove={remove}/>
        </div>
    )
}


